import styles from './tableActionButtons.module.css';

const TableActionButtons = ({ children }) => {
  return (
    <div id="action-buttons" className={styles.container}>
      {children}
    </div>
  );
};

export default TableActionButtons;
